/**
 * Типы сделок модуля elita.
 * Используются при регистрации deal type и при фильтрации в клиентских расширениях.
 */
export const ELITA_DEAL_TYPES = {
  ORDER: 'ELITA_ORDER',
} as const;

/**
 * Статусы сделок типа ELITA_ORDER.
 */
export const ELITA_DEAL_STATUSES = {
  ORDER_NEW: 'ELITA_ORDER_NEW',
  ORDER_SELECTING: 'ELITA_ORDER_SELECTING',
  ORDER_CONFIRMED: 'ELITA_ORDER_CONFIRMED',
  ORDER_PROGRESS: 'ELITA_ORDER_IN_PROGRESS',
  ORDER_CLOSED: 'ELITA_ORDER_CLOSED',
  ORDER_CANCELED: 'ELITA_ORDER_CANCELED',
} as const;

/**
 * Источники лидов модуля elita.
 * Каналы, через которые менеджеры/маркетинг получают новые контакты.
 * Регистрируются через defineLeadSource (upsert по code, безопасно для других инстансов).
 */
export const ELITA_LEAD_SOURCES = {
  COLD_CALL: 'COLD_CALL',
  EXHIBITION: 'EXHIBITION',
  INBOUND_CALL: 'INBOUND_CALL',
  WEBSITE: 'WEBSITE',
  REFERRAL: 'REFERRAL',
  REACTIVATION: 'REACTIVATION',
} as const;

/**
 * Базовые теги «Тип торговой точки» для партнёров CUSTOMER.
 * Регистрируются как обычные CRM-теги (crm_tags) при старте сервера.
 * Менеджеры назначают их на партнёра через стандартное поле «Теги» в карточке;
 * могут добавлять свои теги через /crm/settings/tags.
 */
export const ELITA_POINT_TYPE_TAGS = ['ТЦ', 'Бутик', 'Онлайн', 'Маркетплейс'] as const;
